import { render, staticRenderFns } from "./CreditDepositList.vue?vue&type=template&id=01ba0e70"
import script from "./CreditDepositList.vue?vue&type=script&lang=js"
export * from "./CreditDepositList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports